import { render, staticRenderFns } from "./SubAccount.vue?vue&type=template&id=96b2a9e4&scoped=true&"
import script from "./SubAccount.vue?vue&type=script&lang=js&"
export * from "./SubAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b2a9e4",
  null
  
)

export default component.exports